import type { FC } from 'react';

/**
 * PendingInvitationModal - Stub component
 * Shows pending staff invitations to users
 */
export const PendingInvitationModal: FC = () => {
  // Stub implementation - no UI shown for now
  return null;
};
